export const messages = {
  cnpjError: 'O CNPJ digitado não é válido, por favor tente novamente.',
  cnaeError:
    'CNAE inválido. A atividade referente ao código não autoriza a habilitação dos produtos Alelo.'
};

export const messagesOverwrite = {
  cnpjError:
    'O CNPJ digitado não é válido, por favor, verifique o valor informado e tente novamente!',
  cnaeError:
    'CNAE inválido. A atividade referente ao código não autoriza a habilitação dos produtos Alelo.'
};
